import { createAPIModule } from 'utility/redux/apiModuleHelpers';
// import { createSelector } from 'reselect';

const getStateSlice = (state) => state.api.storm.backup.details;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'STORM_BACKUP_DETAILS',
	method: 'POST',
	url: '/storm/backup/details.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
